var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5SecForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.225L11.9107 3.95004C12.2498 3.47527 12.4194 3.23788 12.3123 3.01739C12.2052 2.79689 11.9332 2.78426 11.3889 2.75901C11.26 2.75303 11.1303 2.75 11 2.75C6.44365 2.75 2.75 6.44365 2.75 11C2.75 15.5563 6.44365 19.25 11 19.25C15.5563 19.25 19.25 15.5563 19.25 11C19.25 8.3009 17.9538 5.90454 15.95 4.3994",
    stroke: "#1E1F26",
    strokeWidth: 1.2375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8334 8.25H10.0008C9.78238 8.25 9.59428 8.40418 9.55138 8.61841L9.16675 10.5417C9.80264 10.3902 10.4093 10.2143 11.0655 10.2143C12.0419 10.2143 12.8334 11.0058 12.8334 11.9821C12.8334 12.9585 12.0419 13.75 11.0655 13.75C10.3071 13.75 9.40756 13.7659 9.19599 12.8333",
    stroke: "#1E1F26",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5SecForward);
export default __webpack_public_path__ + "static/media/5-sec-forward.5d82b294fb84f9229f7daa5c4e1e1c83.svg";
export { ForwardRef as ReactComponent };